import script from "./line-item-recommendations.vue?vue&type=script&setup=true&lang=js"
export * from "./line-item-recommendations.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__